
<div [@trigger]=trig (@trigger.done)="set($event)">
<div class='outerFlex instruction'>
    <img *ngIf="!!innerImg" alt="instruction gif" src={{innerImg}} class='gif'>
    <h2 class='centered'>{{innerText}}</h2>
  </div>
</div>